import React, { useState } from "react"
import { Box, TextField, Button, Typography, Paper, IconButton } from "@mui/material"
import { ChevronLeft } from "@mui/icons-material"
import { useNavigate } from "react-router-dom"
import api from "../../services/api"
import { API_ENDPOINTS } from "../../config/api"
import { useAuth } from '../../context/AuthContext';
export default function CreateSensorType() {
  const navigate = useNavigate()
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    name: "",
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = async (event, createAnother = false) => {
    event.preventDefault()
    setLoading(true)
    setError(null)
    try {
      await api.post(API_ENDPOINTS.SENSOR_TYPE.CREATE, {
        ...formData,
        client_id: user.clientId
      })
      if (!createAnother) {
        navigate("/sensor-types")
      } else {
        setFormData({ name: "" })
      }
    } catch (err) {
      console.error("Error creating sensor type:", err)
      setError("Failed to create sensor type. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  const handleChange = (event) => {
    const { name, value } = event.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  return (
    <Box sx={{ width: "100%", pr: 2, pt: 0, backgroundColor: "background.paper", borderRadius: 8 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
        <IconButton
          onClick={() => navigate("/sensor-types")}
          sx={{
            mr: 2,
            color: "text.secondary",
            "&:hover": {
              backgroundColor: "action.hover",
            },
          }}
        >
          <ChevronLeft />
        </IconButton>
        <Typography variant="h4" sx={{ fontWeight: "bold" }}>
          Create Sensor Type
        </Typography>
      </Box>

      <Paper
        sx={{
          p: 2,
          borderRadius: 6,
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          backgroundColor: "background.paper",
        }}
      >
        <Box component="form" onSubmit={(e) => handleSubmit(e, false)}>
          {error && (
            <Typography color="error" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}
          <Box sx={{ mb: 3 }}>
            <TextField
              required
              fullWidth
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 20,
                  "& fieldset": {
                    borderColor: "#E0E0E0",
                  },
                  "&:hover fieldset": {
                    borderColor: "#C41747",
                  },
                },
              }}
            />
          </Box>

          <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
            <Button
              type="submit"
              variant="contained"
              disabled={loading}
              sx={{
                bgcolor: "#E31B54",
                color: "#FFFFFF",
                textTransform: "none",
                borderRadius: 20,
                px: 4,
                "&:hover": { bgcolor: "#C41747" },
              }}
            >
              {loading ? "Creating..." : "Create"}
            </Button>
            <Button
              variant="outlined"
              onClick={(e) => handleSubmit(e, true)}
              sx={{
                color: "#E31B54",
                borderColor: "#E31B54",
                textTransform: "none",
                borderRadius: 18,
                px: 4,
                "&:hover": {
                  borderColor: "#C41747",
                  bgcolor: "rgba(227, 27, 84, 0.04)",
                },
              }}
            >
              Create & create another
            </Button>
            <Button
              variant="outlined"
              onClick={() => navigate("/sensor-types")}
              sx={{
                color: "#F9826E",
                borderColor: "#F9826E",
                textTransform: "none",
                borderRadius: 18,
                "&:hover": {
                  color: "black",
                  borderColor: "#F7583D",
                  bgcolor: "#F9826E",
                },
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}
